import { G, Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Barbed_Wire: React.FC<Props> = ({ fill }) => {
    return (
        <Svg height="100%" width="12pt" viewBox="0 0 609.619 609.619">
            <G>
                <G id="Page-1_42_">
                    <G id="_x30_43---Barbed-Wire" clip-rule="evenodd" fill-rule="evenodd" transform="translate(0 -1)">
                        <Path
                            fill={fill}
                            id="Path_321_"
                            d="m491.244 98.263-10.886-29.893c-.408-1.261-1.604-2.096-2.928-2.047h-.065c-1.283-.057-2.452.735-2.874 1.949l-139.516 344.227c-1.729 4.238-1.678 8.994.142 13.194 1.838 4.29 5.32 7.662 9.667 9.362 9.064 3.478 19.259-.803 23.122-9.71l122.936-303.655c3.036-7.489 3.179-15.839.402-23.427z"
                        />
                        <Path
                            fill={fill}
                            id="Path_320_"
                            d="m397.569 185.95c-1.838-4.296-5.325-7.673-9.678-9.373-2.11-.835-4.36-1.264-6.63-1.263-7.193-.029-13.686 4.307-16.416 10.962l-91.443 226.223c-1.724 4.235-1.673 8.986.142 13.183 1.841 4.298 5.332 7.676 9.689 9.373 9.043 3.472 19.214-.814 23.046-9.71l91.443-226.212c1.725-4.236 1.67-8.989-.153-13.183z"
                        />
                        <Path
                            fill={fill}
                            id="Path_319_"
                            d="m326.298 176.577c-2.107-.834-4.353-1.263-6.619-1.263-7.203-.033-13.706 4.308-16.438 10.973l-8.132 20.128c-.109.294-.152.61-.272.904l-35.63 87.905-47.397 117.275c-1.729 4.234-1.678 8.987.142 13.183 1.838 4.296 5.325 7.673 9.678 9.373 9.046 3.473 19.221-.812 23.057-9.71l91.443-226.212c1.729-4.234 1.678-8.987-.142-13.183-1.842-4.298-5.333-7.676-9.69-9.373z"
                        />
                        <Path
                            fill={fill}
                            id="Path_318_"
                            d="m274.938 198.196c1.387-3.989 1.235-8.352-.425-12.236-1.838-4.29-5.32-7.662-9.667-9.362-2.116-.86-4.378-1.3-6.662-1.295-7.206.005-13.701 4.348-16.46 11.006l-122.935 303.634c-3.047 7.486-3.191 15.84-.403 23.427l10.886 29.893c.404 1.245 1.577 2.077 2.885 2.047 1.299.058 2.487-.73 2.939-1.949l101.904-251.392z"
                        />
                        <Path
                            fill={fill}
                            id="Path_317_"
                            d="m477.408 545.309c1.364.028 2.575-.866 2.95-2.177l10.886-29.762c2.774-7.628 2.623-16.013-.425-23.536l-62.769-155.061-19.029 46.984 65.501 161.538c.449 1.206 1.599 2.009 2.886 2.014z"
                        />
                        <Path
                            fill={fill}
                            id="Path_316_"
                            d="m10.886 327.588h150.151l8.774-21.663-8.85-21.881h-150.075c-6.012 0-10.886 4.874-10.886 10.886v21.772c0 6.012 4.874 10.886 10.886 10.886z"
                        />
                        <Path
                            fill={fill}
                            id="Path_315_"
                            d="m609.619 294.93c0-6.012-4.874-10.886-10.886-10.886h-150.14l-8.796 21.707 8.839 21.837h150.097c6.012 0 10.886-4.874 10.886-10.886z"
                        />
                        <Path
                            fill={fill}
                            id="Path_314_"
                            d="m181.558 276.903 19.051-47.039-65.437-161.538c-.36-1.3-1.609-2.148-2.95-2.003-1.3-.036-2.464.802-2.841 2.047l-11.028 29.882c-2.774 7.614-2.619 15.987.435 23.492z"
                        />
                    </G>
                </G>
            </G>
        </Svg>
    );
};

export default Barbed_Wire;
